/** Route language shared by server documents and client-side metadata. */
export function pageLanguage(pathname: string): 'en' | 'ru' {
  return pathname.replace(/\/+$/, '') === '/custom-web' ? 'ru' : 'en'
}
